/**
 * Unified card games constant supporting both Trading Card Games (TCGs)
 * and Sports Cards. Used throughout filters, forms, and detection.
 */

export const CARD_GAMES = [
  // ============= Trading Card Games =============
  // Tier 1: The Big Three
  { value: 'pokemon', label: 'Pokemon', type: 'tcg' },
  { value: 'mtg', label: 'Magic: The Gathering', type: 'tcg' },
  { value: 'yugioh', label: 'Yu-Gi-Oh!', type: 'tcg' },
  
  // Tier 2: Major Players
  { value: 'onepiece', label: 'One Piece', type: 'tcg' },
  { value: 'starwars', label: 'Star Wars: Unlimited', type: 'tcg' },
  
  // Tier 3: Established
  { value: 'digimon', label: 'Digimon', type: 'tcg' },
  { value: 'dragonball', label: 'Dragon Ball', type: 'tcg' },
  { value: 'fab', label: 'Flesh and Blood', type: 'tcg' },
  { value: 'finalfantasy', label: 'Final Fantasy TCG', type: 'tcg' },
  { value: 'gundam', label: 'Gundam', type: 'tcg' },
  
  // Tier 4: Anime/Crossover
  { value: 'weiss', label: 'Weiss Schwarz', type: 'tcg' },
  { value: 'vanguard', label: 'Cardfight!! Vanguard', type: 'tcg' },
  { value: 'unionarena', label: 'Union Arena', type: 'tcg' },
  { value: 'universus', label: 'UniVersus', type: 'tcg' },
  
  // Tier 5: Emerging
  { value: 'grandarchive', label: 'Grand Archive', type: 'tcg' },
  { value: 'battlespirits', label: 'Battle Spirits Saga', type: 'tcg' },
  { value: 'shadowverse', label: 'Shadowverse: Evolve', type: 'tcg' },
  { value: 'riftbound', label: 'Riftbound', type: 'tcg' },
  
  // Lorcana last
  { value: 'lorcana', label: 'Disney Lorcana', type: 'tcg' },
  
  // TCG catch-all
  { value: 'tcg_other', label: 'Other TCG', type: 'tcg' },
  
  // ============= Sports Cards =============
  { value: 'baseball', label: 'Baseball', type: 'sports' },
  { value: 'basketball', label: 'Basketball', type: 'sports' },
  { value: 'football', label: 'Football', type: 'sports' },
  { value: 'hockey', label: 'Hockey', type: 'sports' },
  { value: 'soccer', label: 'Soccer', type: 'sports' },
  { value: 'sports_other', label: 'Other Sports', type: 'sports' },
  
  // ============= General Catch-all =============
  { value: 'other', label: 'Other', type: 'other' },
] as const;

export type CardGame = typeof CARD_GAMES[number]['value'];
export type CardGameType = typeof CARD_GAMES[number]['type'];

// Grouped exports for sectioned dropdowns
export const TCG_GAMES = CARD_GAMES.filter(g => g.type === 'tcg');
export const SPORTS_GAMES = CARD_GAMES.filter(g => g.type === 'sports');

// Helper to get game label by value
export function getGameLabel(value: string | null | undefined): string {
  if (!value) return 'Unknown';
  const game = CARD_GAMES.find(g => g.value === value);
  return game?.label || value;
}

// Helper to get game type
export function getGameType(value: string | null | undefined): CardGameType | 'unknown' {
  if (!value) return 'unknown';
  const game = CARD_GAMES.find(g => g.value === value);
  return game?.type || 'unknown';
}

// ============= Backwards Compatibility =============
// Alias for existing imports
export const TRADING_CARD_GAMES = CARD_GAMES;
export type TradingCardGame = CardGame;
